import { render, staticRenderFns } from "./activityCreateInstituteOrUser.html?vue&type=template&id=6df27518&scoped=true&"
import script from "./activityCreateInstituteOrUser.vue?vue&type=script&lang=js&"
export * from "./activityCreateInstituteOrUser.vue?vue&type=script&lang=js&"
import style0 from "./activityCreateInstituteOrUser.css?vue&type=style&index=0&id=6df27518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df27518",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VAppBar,VImg,VMain,VSpacer,VToolbarTitle})
